import { DIVISION_AI_SKILL } from "../career/matchSetup.js";

/**
 * La dificultad del Partido rapido. Son los mismos niveles de IA que la
 * carrera (ver `ai/skill.ts`), con los mismos nombres: jugar "en Regional" es
 * jugar contra la IA de un club de Regional.
 *
 * Existe por lo medido en produccion el 2026-09-26: contra la IA de siempre, la
 * gente nueva perdia 9 de cada 10 partidos de 3v3.
 */
export type Difficulty = "barrio" | "regional" | "segunda" | "primera";
export const DIFFICULTIES: readonly Difficulty[] = ["barrio", "regional", "segunda", "primera"];

export const DIFFICULTY_LEVEL: Record<Difficulty, number> = {
  barrio: DIVISION_AI_SKILL[0]!,
  regional: DIVISION_AI_SKILL[1]!,
  segunda: DIVISION_AI_SKILL[2]!,
  primera: 1,
};

/**
 * En MAYUSCULAS a proposito: son claves de `t()` distintas de los nombres de
 * division ("Segunda" es "Second Division" en ingles, y en una pastilla no
 * cabe). La letra de la pastilla ya es mayuscula, asi que en español se ve
 * igual.
 */
export const DIFFICULTY_LABEL: Record<Difficulty, string> = {
  barrio: "BARRIO",
  regional: "REGIONAL",
  segunda: "SEGUNDA",
  primera: "PRIMERA",
};

export const DIFFICULTY_HINT: Record<Difficulty, string> = {
  barrio: "fácil",
  regional: "media",
  segunda: "difícil",
  primera: "la de siempre",
};

export const DIFFICULTY_BLURB: Record<Difficulty, string> = {
  barrio: "Torpes, lentos y con resaca. Para empezar.",
  regional: "Ya se defienden. Más o menos.",
  segunda: "Te lo ponen difícil, y encima protestan.",
  primera: "La IA de siempre. Sin piedad.",
};

/** Lo que se pasa a la simulacion. Primera no pasa nada: es la IA de siempre, bit a bit. */
export function difficultySkill(d: Difficulty): { home: number; away: number } | undefined {
  const level = DIFFICULTY_LEVEL[d];
  return level >= 1 ? undefined : { home: level, away: level };
}

export const DIFFICULTY_KEY = "fynta.difficulty";

export function isDifficulty(v: unknown): v is Difficulty {
  return typeof v === "string" && (DIFFICULTIES as readonly string[]).includes(v);
}

/** La guardada en este aparato, o `fallback` si nunca se eligio. */
export function loadDifficulty(fallback: Difficulty): Difficulty {
  try {
    const raw = localStorage.getItem(DIFFICULTY_KEY);
    return isDifficulty(raw) ? raw : fallback;
  } catch {
    return fallback;
  }
}

export function saveDifficulty(d: Difficulty): void {
  try {
    localStorage.setItem(DIFFICULTY_KEY, d);
  } catch {
    // Comodidad: sin almacenamiento, vuelve a la de por defecto.
  }
}
